import camelCase from "lodash/camelCase";
import memoize from "lodash/memoize";
import publicConfig from "../public-config";

// univerial `btoa` function for node
function universalBtoa(inString) {
  if (typeof btoa !== "undefined") {
    return btoa(inString);
  }
  return Buffer.from(inString, "utf-8").toString("base64");
}

export function universalAtob(inString) {
  if (typeof atob !== "undefined") {
    return atob(inString);
  }
  return Buffer.from(inString, "base64").toString("binary");
}

const reformatLdFlags = memoize((flags) =>
  Object.entries(flags).reduce((formattedFlags, flag) => {
    const [key, val] = flag;
    return { ...formattedFlags, ...{ [camelCase(key)]: val?.value } };
  }, {})
);

const fetchLDFlags = memoize(async (fetch) => {
  // Clear cache after a minute so flag changes take effect in a reasonable amount of time.
  // This should only be called on the server but using optional chaining for `unref` just in case.
  setTimeout(() => fetchLDFlags.cache.clear(), 60000).unref?.();

  const user = { key: "aLkdYinjkPdslfk4223ad" };
  const ldUrl = `https://app.launchdarkly.com/sdk/evalx/${
    publicConfig?.launchDarkly.clientSideId
  }/users/${universalBtoa(JSON.stringify(user))}`;

  let response;
  try {
    response = await fetch(ldUrl);
  } catch (error) {
    const connectionError = new Error(`Could not connect to ${ldUrl}`);
    connectionError.response = error;
    throw connectionError;
  }

  if (response.ok) {
    return response.json();
  }

  const { status, statusText } = response;
  const requestError = new Error(
    `Response error while fetching Feature flags at ${ldUrl}. Status: ${status} - ${statusText}`
  );
  requestError.response = response;
  throw requestError;
});

export default async function getLDFlags({ fetch }) {
  const rawFlags = await fetchLDFlags(fetch);
  return reformatLdFlags(rawFlags);
}
